"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelDialogSectionEditor = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_forms_1 = require("@tableau/catalog-forms");
const catalog_help_url_1 = require("@tableau/catalog-help-url");
const catalog_messages_1 = require("@tableau/catalog-messages");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const LabelHelpTooltips_1 = require("../help/LabelHelpTooltips");
const labelCategories_1 = require("../restApi/labelCategories");
const LabelCategories_1 = require("../shared/LabelCategories");
const LabelType_1 = require("../shared/LabelType");
const LabelDialogStyle_1 = require("./LabelDialogStyle");
const LabelsDialogContexts_1 = require("./LabelsDialogContexts");
const Placeholders_1 = require("./Placeholders");
const VerticalTabList_1 = require("./VerticalTabList");
function useLabelExists({ category, value, testId }) {
    var _a, _b;
    const { values } = (0, LabelsDialogContexts_1.useLabelDialogState)();
    const label = (_b = (_a = values === null || values === void 0 ? void 0 : values[category === null || category === void 0 ? void 0 : category.name]) === null || _a === void 0 ? void 0 : _a[value === null || value === void 0 ? void 0 : value.name]) !== null && _b !== void 0 ? _b : undefined;
    return {
        testId,
        category,
        value,
        exists: label ? (!!label.active && !label.tombstone) : false,
    };
}
function LabelDialogSectionEditor() {
    var _a;
    const state = (0, LabelsDialogContexts_1.useLabelDialogControlsState)();
    const details = (0, LabelsDialogContexts_1.useLabelDialogDetails)();
    const value = details.values[(_a = state.value) !== null && _a !== void 0 ? _a : ''];
    if (!value) {
        return react_1.default.createElement(Placeholders_1.Placeholders.Editor, null);
    }
    const category = details.categories[value.category];
    return react_1.default.createElement(LabelEditorInner, { category: category !== null && category !== void 0 ? category : { name: '', description: '' }, value: value, testId: 'value' });
}
exports.LabelDialogSectionEditor = LabelDialogSectionEditor;
function LabelEditorInner(props) {
    const exists = useLabelExists(props);
    return (react_1.default.createElement(LabelDialogStyle_1.LabelDialogBodySection, { width: 460, grow: true, "aria-labelledby": (0, VerticalTabList_1.buildId)('tab', props.value.name), "aria-label": catalog_messages_1.Messages.LabelsDialog_EditorTitle(), role: 'tabpanel', style: {
            padding: 16,
            paddingTop: widgets_1.TabStyles.Spacing.ExtraLargeSpace,
        } },
        react_1.default.createElement(Heading, Object.assign({}, exists)),
        react_1.default.createElement(Description, Object.assign({}, exists)),
        exists.exists && react_1.default.createElement(VisibilitySelector, Object.assign({}, exists)),
        exists.exists && react_1.default.createElement(MessageEditor, Object.assign({}, exists))));
}
const headingTextClass = (0, vizportalclient_common_components_1.cssClass)('heading-text', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    paddingBottom: 16,
    marginBottom: 16,
    borderBottom: LabelDialogStyle_1.border,
});
function Heading(props) {
    const heading = (0, LabelType_1.localizeCategoryAndLabel)(props.category.name, props.value.name);
    return react_1.default.createElement("div", { className: headingTextClass }, heading);
}
const descriptionClass = (0, vizportalclient_common_components_1.cssClass)('description-expando', {
    marginBottom: -4,
    $nest: {
        '& > button': {
            maxWidth: 'fit-content',
        },
    },
});
function Description({ category, value }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(widgets_1.ExpandoWidget, { keepChildrenMounted: true, isInitiallyExpanded: true, alignment: 'right', className: descriptionClass, style: {}, label: react_1.default.createElement("span", null, catalog_messages_1.Messages.Description()) },
            react_1.default.createElement("div", { style: { marginTop: -16, marginBottom: -16 } },
                react_1.default.createElement(DescriptionCategoryPart, { details: category }),
                react_1.default.createElement(DescriptionValuePart, { details: value }))),
        react_1.default.createElement(DescriptionCategoryNote, { details: category })));
}
function DescriptionCategoryPart(props) {
    if ((0, labelCategories_1.isSystemLabelCategory)(props.details)) {
        return null;
    }
    const markup = catalog_messages_1.Messages.LabelsDialog_ValueWithDescription({
        value: `<strong>${props.details.name}</strong>`,
        description: props.details.description,
    });
    return (react_1.default.createElement(widgets_1.TextFormatterDisplayWidget, { title: catalog_messages_1.Messages.LabelsDialog_CategoryDescription(), markup: markup, style: { padding: 0, margin: 0 } }));
}
function DescriptionValuePart(props) {
    const system = (0, labelCategories_1.isSystemLabelCategory)(props.details);
    const markup = system ? props.details.description : catalog_messages_1.Messages.LabelsDialog_ValueWithDescription({
        value: `<strong>${(0, LabelType_1.localizeLabelValueName)(props.details.name)}</strong>`,
        description: props.details.description,
    });
    return (react_1.default.createElement(widgets_1.TextFormatterDisplayWidget, { title: catalog_messages_1.Messages.LabelsDialog_LabelNameDescription(), markup: markup, style: { padding: 0, margin: 0 } }));
}
const DescriptionCategoryNoteDiv = (0, vizportalclient_common_components_1.divWithStyle)('description-category-note', {
    padding: 8,
    marginTop: 8,
    marginBottom: 16,
    backgroundColor: '#EBEBEB',
    fontSize: 12,
    lineHeight: '18px',
});
function DescriptionCategoryNote(props) {
    const note = useInterpolatedCategoryNote(props.details.name.toLowerCase()).map((t, i) => (react_1.default.createElement(react_1.default.Fragment, { key: i }, t)));
    return (react_1.default.createElement(DescriptionCategoryNoteDiv, null, note));
}
const tokens = Object.freeze({
    'certification': 'label-certification',
    'warning': 'dqw-manual',
    'sensitivity': 'label-sensitivity',
    'custom': 'label-custom',
});
function useInterpolatedCategoryNote(category) {
    const href = (0, catalog_help_url_1.useServerHelpUrlByToken)({ helpToken: tokens[(0, LabelCategories_1.isBuiltInLabelCategory)(category) ? category : 'custom'] });
    const learnMoreLink = '[LEARN_MORE_LINK_TOKEN]';
    const link = (react_1.default.createElement(widgets_1.TextLinkWidget, { href: href, testId: 'help', target: '_blank', rel: 'noopener noreferrer' }, catalog_messages_1.Messages.LearnMoreLink()));
    const replacement = { ['LEARN_MORE_LINK_TOKEN']: link };
    if ((0, LabelCategories_1.isBuiltInLabelCategory)(category)) {
        switch (category) {
            case 'certification':
                return (0, catalog_core_1.interpolateString)(catalog_messages_1.Messages.LabelsDialog_DescriptionHelp_Certification({ learnMoreLink }), replacement);
            case 'warning':
                return (0, catalog_core_1.interpolateString)(catalog_messages_1.Messages.LabelsDialog_DescriptionHelp_Warning({ learnMoreLink }), replacement);
            case 'sensitivity':
                return (0, catalog_core_1.interpolateString)(catalog_messages_1.Messages.LabelsDialog_DescriptionHelp_Sensitivity({ learnMoreLink }), replacement);
        }
    }
    else {
        return (0, catalog_core_1.interpolateString)(catalog_messages_1.Messages.LabelsDialog_DescriptionHelp_Custom({ learnMoreLink }), replacement);
    }
}
const VisibilitySelectorLabel = (0, vizportalclient_common_components_1.divWithStyle)('visibility-selector-style', {});
function VisibilitySelector(props) {
    const category = props.category.name.toLowerCase();
    const buttons = [
        {
            label: react_1.default.createElement("div", null, catalog_messages_1.Messages.labelStandardVisibility()),
            testId: 'standard-visibility',
            value: 'standard',
        },
        {
            label: react_1.default.createElement("div", null, catalog_messages_1.Messages.labelHighVisibility()),
            testId: 'high-visibility',
            value: 'severe',
        },
    ];
    const label = (react_1.default.createElement(VisibilitySelectorLabel, null,
        catalog_messages_1.Messages.LabelsDialog_VisibilitySelectorTitle(),
        react_1.default.createElement(LabelHelpTooltips_1.VisibilityTooltip, null)));
    if ((0, LabelCategories_1.isBuiltInLabelCategory)(category) && category === 'warning') {
        return (react_1.default.createElement("div", { style: { marginBottom: 24 } },
            react_1.default.createElement(catalog_forms_1.FormikRadioButtonGroup, { label: label, config: { name: `${props.category.name}.${props.value.name}.elevated` }, buttonList: buttons })));
    }
    return null;
}
function MessageEditor(props) {
    return (react_1.default.createElement(catalog_forms_1.FormikTextFormatterWidget, { label: catalog_messages_1.Messages.LabelsDialog_MessagesTitle(), config: { name: `${props.category.name}.${props.value.name}.message` }, subtleValid: true }));
}
//# sourceMappingURL=LabelsDialogSectionEditor.js.map